import React from 'react';
import {FaSpinner} from '../../../node_modules/react-icons/fa';
import styles from './Spinner.module.css';

const Spinner = () => {
  return (
    <div className={styles.spinner}>
    <FaSpinner />
    </div>
  )
}

export default Spinner